export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            投稿爆料
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[600px] mx-auto">
            你有猛料？欢迎向51吃瓜黑料投稿，一起吃大瓜
          </p>
        </div>

        <div className="max-w-[700px] mx-auto">
          <div className="rounded-2xl bg-background-50 border border-background-200/50 p-8 md:p-10 text-center">
            <div className="w-16 h-16 mx-auto mb-5 rounded-2xl bg-primary-100 flex items-center justify-center">
              <i className="ri-mail-send-line text-3xl text-primary-500"></i>
            </div>

            <h3 className="text-xl font-heading text-foreground-950 mb-3">
              把你的猛料告诉我们
            </h3>
            <p className="text-sm text-foreground-600 mb-8 leading-relaxed max-w-[480px] mx-auto">
              如果你手上有娱乐圈、网红圈、商界名人的独家爆料或51吃瓜黑料视频线索，
              欢迎通过以下方式联系我们。所有投稿严格保密，爆料人信息绝不外泄。
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="#footer"
                className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-bold text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2"
              >
                <i className="ri-send-plane-fill"></i>
                立即投稿
              </a>
              <div className="flex items-center gap-3 text-sm text-foreground-600">
                <span className="flex items-center gap-1">
                  <i className="ri-mail-line text-primary-500"></i>
                  tips@51chigua.com
                </span>
                <span className="text-foreground-400">|</span>
                <span className="flex items-center gap-1">
                  <i className="ri-shield-check-line text-accent-500"></i>
                  严格保密
                </span>
              </div>
            </div>

            <div className="mt-8 pt-6 border-t border-background-200/50">
              <div className="flex flex-wrap items-center justify-center gap-6 text-xs text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-checkbox-circle-fill text-accent-500"></i>
                  24小时内回复
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-checkbox-circle-fill text-accent-500"></i>
                  匿名保护
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-checkbox-circle-fill text-accent-500"></i>
                  稿费从优
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}